// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Routes
import paths from './paths'

function route (path, view, name) {
  return {
    name: name || view,
    path,
    component: (resolve) => import(/* webpackChunkName: "views/[request]" */ '@/views/' + view + '.vue').then(resolve)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name)).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.loggedIn) {
    store.commit('updateActivity')
  }
  for (let i = 0; i < paths.length; i++) {
    if (paths[i].name === to.name && 'title' in paths[i]) {
      if ('roles' in paths[i] && store.state.loggedIn) {
        let hasRole = false
        for (let j = 0; j < paths[i].roles.length; j++) {
          let role = paths[i].roles[j]
          if (role in store.state.roles) {
            hasRole = true
            break
          }
        }
        if (!hasRole) {
          store.dispatch('main/snackbar', { active: true, color: 'error', timeout: 10000, text: 'You do not have permission to access ' + paths[i].title })
          if (from.path === '/') return
          next('/')
        }
      }
      document.title = paths[i].title
    }
  }
  next()
})

export default router
